/**
 * PaymentModal.jsx - 예약 결제 신규/수정 모달
 */
import React, { useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { PAYMENT_METHOD_OPTS } from '../reservationFormConfig';
import { Field, Modal, Grid } from './_modal-helpers';

function ymd(v) {
  if (!v) return null;
  if (v instanceof Date) return `${v.getFullYear()}-${String(v.getMonth()+1).padStart(2,'0')}-${String(v.getDate()).padStart(2,'0')}`;
  return String(v).slice(0, 10);
}

function normalizePaymentForm(form = {}) {
  if (form.payment_method !== 'card') return form;
  return { ...form, cash_receipt_issue_no: null, cash_receipt_amount: null };
}

export default function PaymentModal({ travelCode, row, onClose, onSaved }) {
  const isNew = !row;
  const [form, setForm] = useState(row ? { ...row, payment_date: ymd(row.payment_date) } : {});
  const [saving, setSaving] = useState(false);
  const upd = (k) => (v) => setForm((f) => normalizePaymentForm({ ...f, [k]: v }));
  const isCash = form.payment_method === 'cash';

  async function handleSave() {
    if (form.amount !== null && form.amount !== undefined && form.amount !== '') {
      if (!form.payment_date) { alert('금액이 입력된 결제는 지불일을 입력해 주세요.'); return; }
      if (!form.payment_method) { alert('금액이 입력된 결제는 지불수단을 입력해 주세요.'); return; }
    }
    setSaving(true);
    try {
      const payload = normalizePaymentForm(form);
      const r = isNew
        ? await apiClient.post(`/api/admin/reservations/${encodeURIComponent(travelCode)}/payments`, payload)
        : await apiClient.put(`/api/admin/reservation-payments/${row.id}`, payload);
      if (r.ok && r.data?.success) { onSaved && onSaved(); onClose(); }
      else alert(r.data?.message || '저장 실패');
    } catch (e) { alert('오류: ' + e.message); }
    finally { setSaving(false); }
  }

  return (
    <Modal title={isNew ? '결제 추가' : `결제 수정 #${row.id}`} onClose={onClose} onSave={handleSave} saving={saving}>
      <Grid>
        <Field label="지불일" type="date" value={form.payment_date} onChange={upd('payment_date')} />
        <Field label="고객지불(E)" type="amount" value={form.amount} onChange={upd('amount')} />
        <Field label="지불수단" value={form.payment_method} onChange={upd('payment_method')} options={PAYMENT_METHOD_OPTS} />
        {isCash && <Field label="현금영수증 번호(R)" value={form.cash_receipt_issue_no} onChange={upd('cash_receipt_issue_no')} />}
        {isCash && <Field label="현금영수증 금액(S)" type="amount" value={form.cash_receipt_amount} onChange={upd('cash_receipt_amount')} />}
      </Grid>
    </Modal>
  );
}
